export type { DrawerFormContext, UseDrawerFormOpts } from '@pkg/form/forms/useDrawerForm'
export { useDrawerForm } from '@pkg/form/forms/useDrawerForm'

import { DrawerForm, type DrawerFormProps } from '@ant-design/pro-components'
import { t } from '@lingui/core/macro'
import { toast } from '@pkg/ui/toast'
import type { AnyFormApi } from '@tanstack/react-form'
import type { ReactNode } from 'react'
import { FormAlerts } from '../components/FormAlerts'
import {
  EditableFormContext,
  type EditableFormMeta,
  type EditablePolicy,
  useEditableForm,
} from '../contexts/editableForm'
import { useOptionalFormContext } from '../createAppFormHook'
import { mergeFormProps } from '../utils/mergeFormProps'

export type AppDrawerFormProps<T = Record<string, unknown>> = Omit<DrawerFormProps<T>, 'form'> & {
  editablePolicy?: Partial<EditablePolicy>
  meta?: Partial<EditableFormMeta>
  form?: AnyFormApi
}

export function AppDrawerForm<T = Record<string, unknown>>(props: AppDrawerFormProps<T>) {
  const { editablePolicy, meta, form: formFromProps, ...rest } = props
  const form = useOptionalFormContext(formFromProps)
  const editable = useEditableForm({
    initialPolicy: { forceMode: 'edit' },
    initialMeta: meta,
  })
  const merged = mergeFormProps(
    form,
    {
      ...rest,
      submitter: {
        searchConfig: {
          submitText: t`Übernehmen`,
        },
      },
    },
    editable,
    toast,
  )

  return (
    <EditableFormContext value={editable as never}>
      <DrawerForm {...merged}>
        <FormAlerts />
        {rest.children as ReactNode}
      </DrawerForm>
    </EditableFormContext>
  )
}
